import Text from 'components/Text/Text';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';
import React, { useContext, useRef } from 'react';
import { Select } from 'antd';
import { IGetCustomersShort, EntityStatus } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';
import { getCustomersShortInfo } from 'backend/customers';
import style from './CustomerField.module.scss';

const { Option } = Select;

const CustomerField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading } = useFetchData<IGetCustomersShort, null>(getCustomersShortInfo);

	return (
		<div className={style.container} data-test="customerLabel">
			<Text translationNameSpace="form" translationKey="customerLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				value={deviceForFullInfo?.customerId || '-'}
				loading={loading}
				bordered={false}
				showArrow={false}
				disabled={true}
				listItemHeight={response?.data.customers.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				{response?.data.customers.length ? (
					<>
						{response.data.customers.map((el) => {
							return (
								<Option className={style.listItem} value={el.id} key={el.id}>
									{el.name}
									{el.status === EntityStatus.Archived && <ArchivedLabel />}
								</Option>
							);
						})}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default CustomerField;
